import { useState,useRef, useEffect } from "react";
import "./css/Login.css"
import { server_URL, mainDB, setSS, getSS } from "./index.js"


function Login(){
  const usernameRef = useRef(null)
  const passwordRef = useRef(null)
  const loading_ref = useRef(null)
  const [globalmessage,setglobalmessage] = useState("")

  function displayglobalmessage(message){
    setglobalmessage(message)
    setTimeout(()=>{setglobalmessage("")},1200)
  }
  async function enter_function(keyPressed,id){
    if(keyPressed!="Enter"){
      return
    }

    if (id=="username"){
      passwordRef.current.focus()
      passwordRef.current.value = ""
      return
    }
    const username = usernameRef.current.value
    const password = passwordRef.current.value
    
    if(username==""||username==null){
        displayglobalmessage("username can't be empty")
        return
    }
    if(password==""||password==null){
        displayglobalmessage("password can't be empty")
        return
    }

    
    loading_ref.current.style.display = "flex"
    try {
      const output = await fetch(server_URL()+"userlogin",{
          method:"POST",
          headers:{
          "Content-Type":"application/json"
          },
          body:JSON.stringify({
          "username":username,
          "password":password
          })
      })
      .then(response=>response.json())
      .then(data=>data)
      if(output["status"]=="false"){
          displayglobalmessage(output["message"])
          return
      }
      const nextlocation = output["site"].replace("[USERCACHE]",output["cache"])
      setSS("main_cached",output["cache"])

      window.location.href = mainDB()?nextlocation.replace("https://parodewnova.com","http://localhost:3000"):nextlocation
    } catch (error) {
      displayglobalmessage("error connecting to server")
    }
    finally{
      loading_ref.current.style.display = "none"
    }
  }
  async function cachedlogin(){
      try {
          const response = await fetch(server_URL()+"defaultclienturl")
          const clienturl = await response.text()

          const nextLocation = clienturl.replace("[USERCACHE]",getSS("main_cached"))
          window.location.href = mainDB()?nextLocation.replace("https://parodewnova.com","http://localhost:3000"):nextLocation
      } catch (error) {
        displayglobalmessage("(cache login failed) error connecting to server")
      }
  }
  
  useEffect(()=>{
    usernameRef.current.focus()

    if(getSS("main_cached")==null||getSS("main_cached")==""){
        return
    }


    cachedlogin()
  },[])
  return(
    <div id="loginscreen" style={{position:"absolute",width:"100%",height:"100%",background:"white"}}>
      <div className="globalmessagecss" style={{display:globalmessage==""?"none":"block"}}>{globalmessage}</div>
      <div className="loginpageparentcss">
        <div style={{width:"100%",margin:"3px",textAlign:"center",fontFamily:"Roboto",fontSize:"14px",fontWeight:"bold",margin:"3px"}}>Login (test server)</div>
        <input ref={usernameRef} style={{width:"85%",marginBottom:"7px",height:"15px",border:"none",borderRadius:"5px"}} placeholder='user' onKeyDown={(e)=>enter_function(e.key,"username")}></input>
        <input ref={passwordRef} style={{width:"85%",marginBottom:"4px",height:"15px",border:"none",borderRadius:"5px"}} placeholder='password' type='password' onKeyDown={(e)=>enter_function(e.key,"password")}></input>
        {/* <button style={{width:"40%",marginBottom:"4px"}} onClick={loginmodule}>login</button> */}
        <img ref={loading_ref} src={server_URL()+"fetchcontent/gallery-assests/Loading.gif"} style={{position:"absolute",left:"50%",top:"50%",transform:"translate(-50%,-10%",width:"100px",objectFit:"contain",display:"none"}}></img>
      </div>
    </div>
  )
}

export default Login